import $ from 'jquery';

const dataKey = '_valueChangeLastValue';

function isInput(element) {
    return $(element).is(':input, [contenteditable]');
}

// Получает значение элемента. Особый случай — contentEditable,
// в качестве значения используем html-содержимое.
const getValue = function(element) {
    if (element.contentEditable === 'true') {
        return $(element).html();
    }
    return $(element).val();
};

// Фиксирует значение инпута для определения последующих изменений.
const fixPreviousValue = function(element, value) {
    $(element).data(dataKey, value);
};

// Возвращает зафиксированное значение инпута.
const getPreviousValue = function(element) {
    return $(element).data(dataKey);
};

// Возвращает элемент с фокусом внутри родителя или `undefined`.
const getActiveChild = function(element) {
    if (document.activeElement && $.contains(element, document.activeElement)) {
        return document.activeElement;
    }

    return null;
};

// Триггерит событие, если значение элемента изменилось.
const triggerIfChanged = function(element) {
    const $element = $(element);
    const lastValue = getPreviousValue(element);
    const currentValue = getValue(element);
    if (currentValue !== lastValue) {
        fixPreviousValue(element, currentValue);
        $element.trigger('valuechange', [lastValue]);
    }
};

/**
 * Событие изменения пользователем значения текстового поля.
 * Не срабатывает, если значение не поменялось.
 * Передаёт в параметре предыдущее значение.
 *
 * @param {Object} previousValue  Предыдущее значение или `undefined`.
 *
 * @event valuechange
 */
$.event.special.valuechange = {
    // Выполняется при навешивании на текущий элемент первого обработчика.
    setup() {
        // В момент наступления этих событий значение уже новое.
        // `change` для реакции на изменение значения в JS с последующим `trigger('change')`.
        $(this).on('input.valuechange change.valuechange', (event) => {
            triggerIfChanged(event.target);
        });

        // В момент наступления этих событий значение ещё не изменилось.
        //  (`input` не триггерится, в момент `dragend` значение ещё старое).
        $(this).on('cut.valuechange paste.valuechange', (event) => {
            window.setTimeout(() => {
                triggerIfChanged(event.target);
            }, 0);
        });

        // Нужно вернуть false, чтобы jQuery стал слушать в том числе и события браузера
        return false;
    },

    // Выполняется при каждом навешивании на текущий элемент обработчика.
    add(handleObj) {
        const $this = $(this);

        // Для правильной работы нужно фиксировать значение инпута до ввода,
        // сравнивать его со значением после ввода и триггерить событие при наличии
        // изменений. Если событие вешается непосредственно на инпут, можно зафиксировать
        // его текущее значение сразу, но при делегировании неизвестно, на каком
        // элементе произойдёт ввод, поэтому будем фиксировать старое значение по событиям
        // `drop` и `focusin` (при перетаскивании текста `drop` выстреливает
        // со старым значением, а `focusin` уже с новым, поэтому нельзя ограничиться `focusin`).
        $this.on('drop.valuechange focusin.valuechange', handleObj.selector, (event) => {
            // Событие может прилететь и не с инпута.
            if (isInput(event.target)) {
                // Фиксируем текущее значение, если оно не было зафиксировано ранее.
                // Важно: если на этом инпуте уже был обработчик `valuechange`, и с тех пор
                // значение инпута поменялось, зафиксированным останется старое. Фиксировать
                // значение безусловно по `focusin` нельзя, потому что при перетаскивании текста
                // в момент `focusin` значение уже новое, к тому же поле всё это время могло
                // быть в фокусе и `focusin` просто не произойдёт.
                if (typeof getPreviousValue(event.target) === 'undefined') {
                    fixPreviousValue(event.target, getValue(event.target));
                }
            }
        });

        // Специальное событие для фиксации текущего значения. Может использоваться
        // другими скриптами в сложных случаях (отсутствие событий, изменение значения скриптом).
        $this.on('fixValue.valuechange', handleObj.selector, (event) => {
            fixPreviousValue(event.target, getValue(event.target));
        });

        // При навешивании события прямо на инпут подготавливаем его, не дожидаясь фокуса.
        if (isInput(this)) {
            // Если сохранённое значение уже есть, перезаписываем его, т.к. оно могло остаться
            // от других обработчиков `valuechange`, значение инпута с тех пор могло поменяться.
            fixPreviousValue(this, getValue(this));
        } else {
            // Если в момент делегирования внутри текущего элемента уже есть контрол
            // с фокусом, нужно зафиксировать его значение. Не фиксируем его напрямую, потому что
            // активный контрол может не подходить нам по селектору (событие в этом случае просто
            // всплывёт мимо). Не проверяем здесь селектор, потому что он может указывать на любой
            // элемент, слушающий всплывающие через него события, например, тут селектор == 'form':
            // `$('div').on('valuechange', 'form', handler);`
            const activeChild = getActiveChild(this);
            if (activeChild) {
                $(activeChild).trigger('fixValue.valuechange');
            }
        }
    },

    // Выполняется при каждом удалении обработчика с текущего элемента.
    remove(handleObj) {
        // Удаляем наблюдение за внутренними элементами при делегировании.
        $(this).off('drop.valuechange focusin.valuechange', handleObj.selector);
    },

    // Выполняется при удалении с текущего элемента последнего обработчика.
    teardown() {
        $(this).off('.valuechange');
    },
};
